import { useEffect, useState } from 'react';
import './Styles/sidebar.css';
import { Box, makeStyles, MenuItem, FormControl, Select } from '@material-ui/core';
//helpers.
import { getCatalogo } from './helpers';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';

let scrollsSettings = {
  overflow: 'scroll',
  overflowX: 'hidden',
};
let webkitScrollbar = {
  background: 'white',
  borderStyle: 'solid',
  borderWidth: '1px',
  borderColor: '#beb1b18f',
  color: 'red',
  width: '9px',
};
let webkitscrollbarTrack = {
  background: '#dfdfe957',
};

const useStyles = makeStyles(theme => ({
  root: {
    border: '1px solid #b5b5b578',
    // padding: '5px',
    width: '300px',
    flex: 1,
    minHeight: 0, // clave para que el overflow funcione dentro de flex
    overflowY: 'auto',
    overflowX: 'hidden',
    ...scrollsSettings,
    '&::-webkit-scrollbar': {
      //son los estilos de las barras scroll en una variable.
      ...webkitScrollbar,
    },
    '&::-webkit-scrollbar-track': {
      //son los estilos de las barras scroll en una variable.
      ...webkitscrollbarTrack,
    },
    '&::-webkit-scrollbar-thumb': {
      background: theme.palette.primary.main,
    },
    '@media (max-width: 960px)': {
      width: '100%',
    },
  },
  devicesLabel: {
    color: 'rgba(0, 0, 0, 0.54)',
    fontSize: '0.75rem',
  },
  input: {
    '& .MuiInputBase-input': {
      // Saco las flechitas al input type number
      '&::-webkit-inner-spin-button': {
        webkitAppearance: "none",
        mozAppearance: "none",
        appearance: " none",
        margin: 0
      },
    },
  },
  selectorModel: {
    width: '100%',
    '& .MuiSelect-select': {
      minHeight: 40,
      paddingTop: 8,
      paddingBottom: 8,
      paddingLeft: 10,
      display: 'flex',
      alignItems: 'center',
      color: theme.palette.primary.main,
    },
  }
}));

const Sidebar = ({ valueSelectorModel, setValueSelectorModel, componentType }) => {
  const classes = useStyles();
  const onDragStart = (event, nodeType) => {
    event.dataTransfer.setData('application/reactflow', nodeType);
    event.dataTransfer.effectAllowed = 'move';
  };
  const [blocks, setBlocks] = useState({})
  const [initialBlocks, seInitialBlocks] = useState({})
  const [inputValue, setInputValue] = useState('')
  const [selectorModels, setSelectorModels] = useState([])

  //Carga catalogo segun componente PLC, ALERT.
  useEffect(() => {
    if (componentType === 'ALERTS_VARIABLES') {
      let res = getCatalogo('ALERTS_VARIABLES', 'generic_data')
      if (res) {
        let blockList = res['order_blocks']
        seInitialBlocks(blockList)
        setBlocks(blockList)
      }
    }
    else {
      let res = getCatalogo('AUTOMATE_DIAGRAMS', 'generic_data')
      if (res) {
        let blockList = res['order_blocks']
        setSelectorModels(res?.all_automates_products)
        //Si no tiene un modelo seleccionado coloco por defecto el modelo 24V-4M el primero de la lista.
        if (valueSelectorModel.length === 0) {
          setValueSelectorModel(res?.all_automates_products[0])
        }
        seInitialBlocks(blockList)
        setBlocks(blockList)
      }
    }


    // eslint-disable-next-line
  }, [])

  let listNoneSvg = ['FFRS', 'CONST', 'VARIABLE', 'ALERT', 'LEQ', 'EQ',
    'LESS', 'GREATER', 'GEQ', 'ADDER', 'DIV', 'MUL', 'GAIN', 'MOD', 'INA', 'INA1', 'IND', 'OUTA', 'OUTD', 'OUTD1', 'INPC', 'LC', 'TC'];

  let elementMap = {
    'FFRS': 'rs',
    'CONST': 'C',
    'VARIABLE': 'V',
    'ALERT': 'A',
    'LEQ': '<=',
    'EQ': '=',
    'LESS': '<',
    'GREATER': '>',
    'GEQ': '>=',
    'ADDER': '+',
    'DIV': '/',
    'MUL': 'x',
    'GAIN': 'G',
    'MOD': '%',
    'INA': 'INA',
    'INA1': 'INA',
    'IND': 'IND',
    'OUTA': 'OTA',
    'OUTD': 'OTD',
    'OUTD1': 'OTD',
    'INPC': 'INPC',
    'LC': 'LC',
    'TC': 'TC',
  };
  const returStringSVG = (element) => elementMap[element] || '';

  const filterCategories = (data, input) => {
    const palabras = input.toLowerCase().split(/\s+/); // Divide el input en palabras ignorando espacios extra
    let resultado = {};
    for (const categoria in data) {
      // Filtrar los elementos que contienen alguna palabra en .name o .key
      const elementosFiltrados = data[categoria].filter(({ name, key }) =>
        palabras.some(palabra =>
          name.toLowerCase().includes(palabra) || key.toLowerCase().includes(palabra)
        )
      );
      // Si hay elementos filtrados, añadir la categoría al resultado
      if (elementosFiltrados.length > 0) {
        resultado[categoria] = elementosFiltrados;
      }
    }
    return resultado;
  };

  const handleInputChange = (e) => {
    let valueAux = e.target.value
    setInputValue(valueAux)
    setBlocks(filterCategories(initialBlocks, valueAux))
  }

  const filterByAutomateModel = (items, model) => {
    return items.filter(item =>
      Array.isArray(item.automates_products) &&
      item.automates_products.includes(model)
    );
  };

  const sortByName = (arr) => {
    let res = arr.sort((a, b) =>
      a.name.localeCompare(b.name, 'es', { sensitivity: 'base' })
    );
    if (componentType === 'ALERTS_VARIABLES') {
      return res
    }
    else {
      return filterByAutomateModel(res, valueSelectorModel)
    }
  }

  const handleChangeModel = (event) => {
    const selectedModel = event.target.value;
    setValueSelectorModel(selectedModel);
  }

  return (
    <Box style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>

      {componentType !== 'ALERTS_VARIABLES' &&
        <Box width={'100%'} >
          <FormControl
            className={classes.selectorModel} // Aplica la clase al FormControl
            variant="standard"
          // disabled={dataDiagramList.length === 0}
          >
            <Select
              className={classes.select} // Aplica la clase al Select
              classes={{
                icon: classes.selectIcon, // Clase para la flechita del selector
              }}
              value={valueSelectorModel} // Valor por defecto vacío
              onChange={handleChangeModel}
            // displayEmpty // Permite mostrar un placeholder cuando no hay valor seleccionado
            >
              {/* Opciones dinámicas */}
              {selectorModels.map(option => (
                <MenuItem
                  key={option}
                  value={option}
                >
                  {option}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      }

      <Box width={'100%'} >
        <Paper
          component="form"
          sx={{ p: '2px 4px', display: 'flex', alignItems: 'center' }}
        >
          <InputBase
            sx={{ ml: 1, flex: 1 }}
            onChange={handleInputChange}
            placeholder="Buscador"
            value={inputValue}
          />
          <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
          {
            inputValue.length > 0 ?
              <IconButton
                onClick={() => { setInputValue(''); setBlocks(initialBlocks) }}
                type="button" sx={{ p: '10px' }} aria-label="search">
                < CloseIcon />
              </IconButton>
              :
              <IconButton
                disabled={true} type="button" sx={{ p: '10px' }} aria-label="search">
                <SearchIcon />
              </IconButton>
          }
        </Paper>
      </Box>
      <Box
        className={classes.root}
      >
        {Object.entries(blocks).map(([sectionKey, items]) => (
          <Box key={sectionKey}>
            <Box ml={1} mt={1}
              style={{
                fontWeight: 'bold',
                userSelect: 'none'
              }}
            >
              {sectionKey}
            </Box>
            {sortByName(items)?.map((elem, indx) => (
              < Box
                key={indx}
                mt={0.5}
                display={'flex'}
                alignItems={'center'}
                onDragStart={(event) => onDragStart(event, elem.key)}
                draggable
                style={{ cursor: 'pointer' }}
              >
                <Box style={{ display: 'flex', backgroundColor: '#f2c84aa1', width: '22px', height: '22px', marginLeft: '3px', }} >
                  {!listNoneSvg.includes(elem?.key) ?
                    <img
                      style={{
                        width: elem.key === 'COUNT' ? '20px' : '25PX',
                        height: '15px',
                        margin: 'auto',
                      }}
                      src={`/images/diagram/${elem?.key?.toLowerCase()}.svg`} alt='svg' />
                    :
                    <Box
                      style={{
                        width: '25px',
                        height: '15px',
                        margin: 'auto',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        fontSize: '10px',
                      }}>
                      {returStringSVG(elem?.key)}
                    </Box>
                  }
                </Box>
                <Box
                  style={{
                    backgroundColor: 'white',
                    color: '#2586bc',
                    border: '1px solid #b5b5b578',
                    borderRadius: '3px',
                    padding: '3px',
                    margin: '0 4px 0 5px',
                    width: '280px',
                    fontSize: '12px',
                  }}
                >
                  {elem?.name}
                </Box>
              </Box>
            ))}
          </Box>
        ))
        }
      </ Box >
    </Box>

  );
};

export default Sidebar

